import { render, staticRenderFns } from "./ConPolizasContablesFormComponent.vue?vue&type=template&id=5c68adbf&"
import script from "./ConPolizasContablesFormComponent.vue?vue&type=script&lang=js&"
export * from "./ConPolizasContablesFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports